/**
 * Sidebar Footer Component
 * Bottom navigation items
 */

import { useLocation, useTranslation } from '@ufc/core'
import { isRtlLanguage } from '@ufc/portal-shared'
import { cn } from '@ufc/uikit'

// App version from build-time environment variable
const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'dev'
import type { SidebarFooterProps } from '../types'
import { BOTTOM_MENU_ITEMS } from '../constants'
import { NavItem } from './nav-item'

// ============================================
// Helper Functions
// ============================================

function isPathActive(currentPath: string, itemPath: string): boolean {
  return currentPath === itemPath
}

// ============================================
// Component
// ============================================

export function SidebarFooter({ collapsed, onNavigate }: SidebarFooterProps) {
  const { i18n } = useTranslation()
  const location = useLocation()
  const isRTL = isRtlLanguage(i18n.language)

  return (
    <div className={cn('border-t border-border/50 transition-[padding,gap] duration-300', collapsed ? 'p-2' : 'p-4')}>
      <ul className="space-y-1.5">
        {BOTTOM_MENU_ITEMS.map((item) => (
          <li key={item.to}>
            <NavItem
              item={item}
              collapsed={collapsed}
              isActive={isPathActive(location.pathname, item.to)}
              isRTL={isRTL}
              onNavigate={onNavigate}
            />
          </li>
        ))}
      </ul>
      {/* Version indicator */}
      <div className={cn(
        'mt-3 pt-3 border-t border-border/30 text-[10px] text-muted-foreground/60',
        collapsed ? 'text-center' : 'text-start'
      )}>
        {collapsed ? `v${APP_VERSION}` : `Version ${APP_VERSION}`}
      </div>
    </div>
  )
}
